import { Link } from 'react-router-dom'
import TypedJS from '../../utils/typed'
import Button from '../button'
import COPY from '../../utils/copy'
import { useState, useEffect } from 'react'
import { createClient } from '@sanity/client'
import { fetchSiteConfigData } from '../../api'
import { toast } from 'react-toastify'

export default function Hero() {
  const [isLoading, setIsLoading] = useState(true)
  const [siteConfigData, setSiteConfigData] = useState<{
    calendly: string
  } | null>(null)

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchSiteConfigData)
      .then((data) => {
        setSiteConfigData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    setIsLoading(false)
  }, [])

  return (
    <section className='h-100% w-screen flex flex-col justify-center items-center bg-landing bg-cover bg-no-repeat bg-center py-24'>
      <TypedJS />
      <div className='w-full flex flex-col sm:flex-row justify-center items-center'>
        <Button
          content={COPY.BOOK_A_CALL}
          link={isLoading ? '#' : siteConfigData?.calendly}
          className='mx-2 max-sm:mb-4'
        />
        <Link to={COPY.CONTACT_URL}>
          <Button content={COPY.GET_IN_TOUCH} className='mx-2' />
        </Link>
      </div>
    </section>
  )
}
